import { getRfiCapabilityBadgeDisplayName } from "./rfiCatalogServiceNames";

/** Canonical "Foundation - All" scope from the RFI catalog (ticket 14201). */
export const FOUNDATION_ALL_RFI_ID = "106c4bdc-e1c2-4fca-9ab6-745b995c65ee";
export const FOUNDATION_ALL_RFI_NAME = "Foundation - All";
/** Legacy catalog name stored on older provider/VQA capability rows. */
export const LEGACY_FOUNDATION_ALL_RFI_NAME = "Core Capabilities";

export function makeFoundationAllSelection() {
  return {
    value: FOUNDATION_ALL_RFI_ID,
    label: FOUNDATION_ALL_RFI_NAME,
  };
}

export function isFoundationAllLabel(name) {
  const n = (name ?? "").toString().trim().toLowerCase();
  return (
    n === FOUNDATION_ALL_RFI_NAME.toLowerCase() ||
    n === LEGACY_FOUNDATION_ALL_RFI_NAME.toLowerCase()
  );
}

export function isFoundationAllSelection(item) {
  if (!item) return false;
  const value = item.value ?? item.rfi_id ?? item;
  const label = (item.label ?? item.rfi_name ?? "").toString().trim();
  return (
    String(value).toLowerCase() === FOUNDATION_ALL_RFI_ID.toLowerCase() ||
    isFoundationAllLabel(label)
  );
}

/** Ensures Foundation - All is present; does not duplicate if already selected. */
export function ensureFoundationAllInSelections(selections = []) {
  if ((selections || []).some(isFoundationAllSelection)) {
    return selections;
  }
  return [makeFoundationAllSelection(), ...(selections || [])];
}

/** Maps API capabilities to dropdown values without injecting Foundation - All (admin edit). */
export function formatCapabilitiesAsSelections(capabilities = []) {
  return (capabilities || []).map((capability) => ({
    value: capability.rfi_id ?? capability.id,
    label: getRfiCapabilityBadgeDisplayName(
      capability.rfi_name ?? capability.name
    ),
  }));
}

/** Maps API capabilities and applies the Foundation - All default (new-request flows). */
export function formatCapabilitiesWithFoundationDefault(capabilities = []) {
  return ensureFoundationAllInSelections(
    formatCapabilitiesAsSelections(capabilities)
  );
}

/** Maps form selections to API capability payloads, always including Foundation - All for sponsors. */
export function toCapabilitiesPayload(selections = [], { lockFoundation = false } = {}) {
  const withFoundation = lockFoundation
    ? ensureFoundationAllInSelections(selections)
    : selections;
  return (withFoundation || []).map((service) => ({
    rfi_id: service.value,
    rfi_name: isFoundationAllLabel(service.label)
      ? FOUNDATION_ALL_RFI_NAME
      : service.label,
  }));
}
